import { ACCOUNT_SUBMENU_MOBILE_ITEMS_KEYS } from 'components/main-nav-bar/constants'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

export const useMenuTranslations = () => {
  const { t: tCommonUI } = useTranslation(['strCommonUI'])
  const { t: tMyAccount } = useTranslation(['strMyAccount'])

  const translatedAccountSubmenuItems = useMemo(
    () =>
      ACCOUNT_SUBMENU_MOBILE_ITEMS_KEYS.map(item => ({
        id: item.id,
        name:
          item.namespace === 'strMyAccount' ? tMyAccount(item.nameKey) : tCommonUI(item.nameKey),
        path: item.path,
      })),
    [tCommonUI, tMyAccount]
  )

  return {
    translatedAccountSubmenuItems,
  }
}
